import { ExportButton } from "@/features/export/layouts/export-button";
import { useDownloadToCsv } from "@/hooks/use-downalod-to-csv";
import { formatCurrency } from "@/utils/format/currency";
import { safeFormatInTimeZone } from "@/utils/format/safe-format-in-time-zone";
import {
  getStatusData,
  calculateTransferAmount,
  getNextBirthDate,
} from "@/features/private-room/contracts/list/utils/private-office-contract";
import { useList } from "@/features/private-room/contracts/list/context/use-list";
import { HEADER_EXPORT_PRIVATE_OFFICE_CONTRACTS } from "@/constants/header-export";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useState } from "react";

export const ButtonExportPoContracts = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { handleExportData } = useList();
  const { handleExport } = useDownloadToCsv({
    exportName: "po-contracts",
    headerCsv: HEADER_EXPORT_PRIVATE_OFFICE_CONTRACTS,
  });

  const handleClickExport = async (extension: string) => {
    setIsLoading(true);
    const data = await handleExportData();

    const convertDataContracts =
      data?.map((item) => {
        return {
          id: item.id,
          company_id: item?.company?.id,
          company_name: item?.company?.name,
          space_id: item?.space?.id,
          space_name: item?.space?.name,
          spot_id: item?.spot?.id,
          spot_name: item?.spot?.label,
          period: `${safeFormatInTimeZone(
            item.startDate,
            "UTC",
            "dd/MM/yyyy",
            "Indeterminado",
          )} - ${safeFormatInTimeZone(
            item.endDate,
            "UTC",
            "dd/MM/yyyy",
            "Indeterminado",
          )}`,
          type: item?.type,
          birthday_date: item?.startDate
            ? getNextBirthDate(item.startDate)
            : "-",
          renewal_indicator: item?.renewalIndicator,
          time_of_use_of_office: item?.startDate
            ? formatDistanceToNow(new Date(item.startDate), {
                locale: ptBR,
              })
            : "-",
          notice_to_client: item?.noticeInDaysCompany
            ? `${item?.noticeInDaysCompany} dias`
            : "-",
          notice_to_partner: item?.noticeInDaysPartner
            ? `${item?.noticeInDaysPartner} dias`
            : "-",
          status: getStatusData(item.status).label,
          cancellation_reason: item?.cancellationReason,
          cancellation_date: safeFormatInTimeZone(
            item?.cancelledAt,
            "UTC",
            "dd/MM/yyyy",
            "-",
          ),
          package_id: item.packageId,
          credits: item.monthlyCredits.toFixed(2),
          take: `${item.takePercentage}%`,
          transfer: formatCurrency(
            calculateTransferAmount(
              item.takePercentage,
              item.partnerPrice.toString(),
            ),
          ),
        };
      }) || [];

    handleExport({ extension, data: convertDataContracts });
    setIsLoading(false);
  };

  return (
    <ExportButton
      handleExport={handleClickExport}
      placeholder="Exportar Contratos"
      isLoading={isLoading}
    />
  );
};
